import classNames from 'classnames';
import type { FC } from 'react';

import MenuItem from './MenuItem';

import styles from './Menu.module.scss';
import type { MenuProps } from './types';

const Menu: FC<MenuProps> = ({
  dataId,
  className,
  items,
  onClick,
  renderIcon,
}) => (
  <div className={classNames(styles.wrapper, className)} data-id={dataId}>
    {items.map((item) => (
      <MenuItem
        key={item.id}
        item={item}
        onClick={onClick}
        renderIcon={renderIcon}
      />
    ))}
  </div>
);

export default Menu;
